import { database } from './config';
import firebase from 'firebase/app';
import { detectDeviceType } from './detectNavigator';

export default class Error {

    guardarError(error) {
        try{
            return new Promise((resolve, reject)=>{
                firebase.auth().onAuthStateChanged(user => {

                    const err = {
                        codigo: error.code ? error.code : '',
                        error: error.message ? error.message : '',
                        fecha: new Date(),
                        dispositivo: detectDeviceType(),
                        usuario: user ? user.email : ''
                    }
        
                    database.collection("errores")
                    .doc()
                    .set(err)
                    .then(resolve(error))
                    .catch(e => reject(e))
                })
            })
        }catch{
        }
        return error
    }

}